import { useEffect, useState } from 'react';
import ExoForm from '../../exo/ExoForm';
import FormFields from '../../form/FormFields';
import { useTranslation } from 'react-i18next';
import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import uuid from 'react-uuid';
import { camelCase } from '../presetEditor/VarList';
import DeleteIcon from '@mui/icons-material/Delete';

export const NewMetaVariableForm = ({
  startData,
  onChange,
  onClose,
  onDelete,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();
  const [dataCollection, setDataCollection] = useState({});

  useEffect(() => {
    if (startData) setDataCollection(startData);
  }, [startData]);

  const fields = [
    {
      label: t('Label'),
      type: 'text',
      key: 'name',
    },
    {
      label: t('Type'),
      key: 'type',
      type: 'customSelect',
      options: [
        { label: 'Text', value: 'text' },
        { label: 'Rich Text', value: 'richTextEditor' },
        { label: 'Number', value: 'number' },
        //{ label: 'Checkbox', value: 'checkbox' },
        { label: 'Money', value: 'money' },
        { label: 'Date', value: 'date' },
      ],
    },
  ];

  const updateDataCollection = (insertData) => {
    setDataCollection({ ...dataCollection, ...insertData });
  };

  function handleSubmit() {
    onChange({
      ...dataCollection,
      key: dataCollection.key || uuid().replace(/-/g, ''),
      value: dataCollection.value || `%%${camelCase(dataCollection.name)}%%`,
      label: dataCollection.name,
    });
    setDataCollection({});
    onClose();
  }

  function handleRemove() {
    onDelete(dataCollection);
    setDataCollection({});
    onClose();
  }

  return (
    <Box
      className="flex flex-col gap-4 rounded-lg p-2"
      sx={{ border: `1px solid ${colors.selected}` }}
    >
      <Box className="flex justify-between items-center">
        <Typography>{t('Custom Variable')}</Typography>
        {dataCollection.key && (
          <IconButton color="error" size="small" onClick={handleRemove}>
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
      <FormFields
        size="small"
        startDataCollection={startData}
        fields={fields}
        dataCollection={dataCollection}
        updateDataCollection={updateDataCollection}
      />
      {Boolean(dataCollection.type) && Boolean(dataCollection.name) && (
        <Box
          className="flex flex-col gap-2 rounded-lg p-2"
          sx={{
            border: `1px solid ${colors.info}80`,
          }}
        >
          <FormFields
            size="small"
            startDataCollection={startData}
            fields={[
              {
                ...dataCollection,
                key: 'preview',
                label: t('Default Value'),
                type:
                  dataCollection.type === 'richTextEditor'
                    ? 'richText'
                    : dataCollection.type,
              },
            ]}
            updateDataCollection={updateDataCollection}
            dataCollection={dataCollection}
          />
        </Box>
      )}
      <Box className="flex gap-1 w-full justify-between">
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            setDataCollection({});
            onClose();
          }}
        >
          {t('Close')}
        </Button>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          {startData?.key ? t('Update') : t('Create')}
        </Button>
      </Box>
    </Box>
  );
};
